import { ref } from 'vue'

/** 弹窗内异步提交：防重复点击，统一 pending 状态 */
export function usePopupAction() {
  const pending = ref(false)

  async function run(action: () => Promise<void>): Promise<void> {
    if (pending.value) return
    pending.value = true
    try {
      await action()
    } finally {
      pending.value = false
    }
  }

  return { pending, run }
}
